<template>
	<v-progress-linear
		:value="value"
		:color="color"
		:height="height"
		:rounded="rounded"
		:buffer-value="bufferValue"
		:stream="stream"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<template v-if="hasDefaultSlot" v-slot:default="{ value: internalValue }">
			<slot :value="internalValue"></slot>
		</template>
	</v-progress-linear>
</template>

<script>
export default {
	name: 'KProgressLinear',
	computed: {
		hasDefaultSlot() {
			return !!this.$scopedSlots.default || !!this.$slots.default;
		}
	},
	model: {
		prop: 'value',
		event: 'input'
	},
	props: {
		value: {
			type: [Number, String],
			default: 0
		},
		color: {
			type: String,
			required: true
		},
		height: {
			type: [String, Number],
			default: undefined
		},
		rounded: Boolean,
		bufferValue: {
			type: [Number, String],
			default: 100
		},
		stream: Boolean
	}
};
</script>